<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CARTE_DELIVERY_LIST')">
        <slot name="section-carte-delivery-list">
          <section-carte-delivery-list ref="CARTE_DELIVERY_LIST"
                                       id="CARTE_DELIVERY_LIST"
                                       :extended="isExtended('CARTE_DELIVERY_LIST')"
                                       :showButton="true"
                                       :autoSave="true"
                                       :readOnly="readOnly"
                                       :moduleId="moduleId"
                                       :searchText="searchText"
                                       :ressourceHeader="ressource"
                                       :fiche="fiche"
                                       :transaction=selectedTransaction
                                       :route="route"
                                       :attribut="attribut"
                                       @extended="setExtended"
                                       @fullscreen="setFullscreen"
                                       @status="updateStatus"
                                       @toggleCardView="toggleCardView"
                                       @updated="deliveryUpdated"
                                       @selectItem = "selectItem">
          </section-carte-delivery-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CARTE_EMITTED_LIST')">
        <slot name="section-carte-emitted-list">
          <section-carte-emitted-list ref="CARTE_EMITTED_LIST"
                                      id="CARTE_EMITTED_LIST"
                                      :extended="isExtended('CARTE_EMITTED_LIST')"
                                      :showButton="true"
                                      :autoSave="true"
                                      :readOnly="readOnly"
                                      :moduleId="moduleId"
                                      :searchText="searchText"
                                      :ressourceHeader="ressource"
                                      :fiche="fiche"
                                      :transaction=selectedTransaction
                                      :route="route"
                                      :attribut="attribut"
                                      @extended="setExtended"
                                      @fullscreen="setFullscreen"
                                      @status="updateStatus"
                                      @toggleCardView="toggleCardView"
                                      @updated="transactionUpdated"
                                      @selectItem = "selectItem">
          </section-carte-emitted-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Transaction from '@/extend/classes/Transaction';
import Delivery from '@/extend/classes/Delivery';
import { storeDelivery } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionCarteDeliveryList from '@/extend/sections/SectionCarteDeliveryListExtend.vue';
import SectionCarteEmittedList from '@/extend/sections/SectionCarteEmittedListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionCarteDeliveryList,
    SectionCarteEmittedList,
    FicheHeader,
  },

  props: {
    transaction: {
      type: Object as PropType<Transaction>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.CARTE_EMIS,
      sections: [
        'CARTE_DELIVERY_LIST',
        'CARTE_EMITTED_LIST',
      ],

      delivery: new Delivery(),
    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_CARTE_EMIS);
    },

    selectedTransaction (): Transaction {
      return this.transaction
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    deliveryUpdated (delivery: Delivery) {
    // To implement
    },

    // eslint-disable-next-line
    transactionUpdated (transaction: Transaction) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.transaction || this.transaction.id < 0) && value == 'CARTE_EMITTED_LIST') {
        this.setExtended(new Extended('CARTE_EMITTED_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
